import React, { useState } from 'react';
import { motion } from 'framer-motion';
import DashboardLayout from '../../components/dashboard/DashboardLayout';
import SafeIcon from '../../common/SafeIcon';
import Button from '../../components/common/Button';
import * as FiIcons from 'react-icons/fi';

const {
  FiSettings,
  FiUser,
  FiCreditCard,
  FiLock,
  FiGlobe,
  FiUsers,
  FiKey,
  FiBell,
  FiCloudLightning,
  FiUpload,
  FiSave,
  FiTrash2,
  FiCheck,
  FiDownload
} = FiIcons;

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const [isLoading, setIsLoading] = useState(false);
  
  const tabs = [
    { id: 'profile', label: 'Profile', icon: FiUser },
    { id: 'subscription', label: 'Subscription', icon: FiCreditCard },
    { id: 'security', label: 'Security', icon: FiLock },
    { id: 'localization', label: 'Localization', icon: FiGlobe },
    { id: 'team', label: 'Team', icon: FiUsers },
    { id: 'api', label: 'API & Integrations', icon: FiCloudLightning },
    { id: 'notifications', label: 'Notifications', icon: FiBell }
  ];

  const handleSave = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'profile':
        return (
          <div className="space-y-6">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
              Profile Settings
            </h2>
            
            <div className="bg-white dark:bg-dark-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6">
                Personal Information
              </h3>
              
              <div className="flex flex-col md:flex-row items-start gap-8 mb-8">
                <div className="w-full md:w-auto flex-shrink-0">
                  <div className="flex flex-col items-center">
                    <div className="w-32 h-32 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden mb-4">
                      <img 
                        src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop&crop=face" 
                        alt="Profile" 
                        className="w-full h-full object-cover" 
                      />
                    </div>
                    <Button variant="outline" size="sm" icon={FiUpload}>
                      Change Photo
                    </Button>
                  </div>
                </div>
                
                <div className="flex-1 w-full space-y-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        First Name
                      </label>
                      <input
                        type="text"
                        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-dark-700 text-gray-900 dark:text-white"
                        defaultValue="John"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Last Name
                      </label>
                      <input
                        type="text"
                        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-dark-700 text-gray-900 dark:text-white"
                        defaultValue="Doe"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Email
                    </label>
                    <input
                      type="email"
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-dark-700 text-gray-900 dark:text-white"
                      defaultValue="john.doe@example.com"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-dark-700 text-gray-900 dark:text-white"
                      defaultValue="+1 (555) 123-4567"
                    />
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-white dark:bg-dark-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6">
                Professional Information
              </h3>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Business Name
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-dark-700 text-gray-900 dark:text-white"
                    defaultValue="John Doe Photography"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Website URL
                  </label>
                  <div className="flex">
                    <span className="inline-flex items-center px-3 rounded-l-lg border border-r-0 border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 text-gray-500 dark:text-gray-400 text-sm">
                      https://
                    </span>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-r-lg focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-dark-700 text-gray-900 dark:text-white"
                      defaultValue="johndoephotography.com"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Bio
                  </label>
                  <textarea
                    rows={4}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-dark-700 text-gray-900 dark:text-white"
                    defaultValue="Professional photographer with over 10 years of experience specializing in portraits and wedding photography."
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Photography Specialties
                  </label>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                    {['Portrait', 'Wedding', 'Landscape', 'Wildlife', 'Product', 'Event', 'Family', 'Commercial'].map((specialty) => (
                      <label key={specialty} className="flex items-center">
                        <input
                          type="checkbox"
                          className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                          defaultChecked={['Portrait', 'Wedding', 'Family'].includes(specialty)}
                        />
                        <span className="ml-2 text-sm text-gray-600 dark:text-gray-300">
                          {specialty}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            
            <div className="flex justify-end space-x-3">
              <Button variant="outline" size="lg">
                Cancel
              </Button>
              <Button size="lg" loading={isLoading} onClick={handleSave} icon={FiSave}>
                Save Changes
              </Button>
            </div>
          </div>
        );
      
      case 'subscription':
        return (
          <div className="space-y-6">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
              Subscription & Billing
            </h2>
            
            <div className="bg-white dark:bg-dark-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Current Plan
                </h3>
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400">
                  Active
                </span>
              </div>
              
              <div className="flex flex-col md:flex-row items-start gap-6 pb-6 mb-6 border-b border-gray-200 dark:border-gray-700">
                <div className="bg-primary-50 dark:bg-primary-900/10 rounded-lg p-4 flex-shrink-0 w-full md:w-auto">
                  <div className="text-xl font-bold text-primary-600 dark:text-primary-400 mb-1">
                    Pro Plan
                  </div>
                  <div className="text-3xl font-bold text-gray-900 dark:text-white mb-1">
                    $19.99<span className="text-sm text-gray-500 dark:text-gray-400">/month</span>
                  </div>
                  <div className="text-sm text-gray-600 dark:text-gray-400">
                    Billed annually ($239.88/year)
                  </div>
                </div>
                
                <div className="flex-1 w-full space-y-4">
                  <div className="space-y-2">
                    <div className="flex items-center">
                      <SafeIcon icon={FiCheck} className="w-5 h-5 text-green-500 mr-2" />
                      <span className="text-gray-600 dark:text-gray-300">Unlimited galleries</span>
                    </div>
                    <div className="flex items-center">
                      <SafeIcon icon={FiCheck} className="w-5 h-5 text-green-500 mr-2" />
                      <span className="text-gray-600 dark:text-gray-300">100 GB storage</span>
                    </div>
                    <div className="flex items-center">
                      <SafeIcon icon={FiCheck} className="w-5 h-5 text-green-500 mr-2" />
                      <span className="text-gray-600 dark:text-gray-300">Advanced editing tools</span>
                    </div>
                    <div className="flex items-center">
                      <SafeIcon icon={FiCheck} className="w-5 h-5 text-green-500 mr-2" />
                      <span className="text-gray-600 dark:text-gray-300">Client proofing & approval</span>
                    </div>
                    <div className="flex items-center">
                      <SafeIcon icon={FiCheck} className="w-5 h-5 text-green-500 mr-2" />
                      <span className="text-gray-600 dark:text-gray-300">E-commerce with 2% fee</span>
                    </div>
                  </div>
                  
                  <div className="flex space-x-3">
                    <Button variant="outline">
                      Change Plan
                    </Button>
                    <Button variant="danger" icon={FiTrash2}>
                      Cancel Subscription
                    </Button>
                  </div>
                </div>
              </div>
              
              <div>
                <h4 className="text-base font-medium text-gray-900 dark:text-white mb-4">
                  Payment Method
                </h4>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-8 bg-gray-200 dark:bg-gray-700 rounded flex items-center justify-center">
                    <span className="text-gray-700 dark:text-gray-300 font-bold text-sm">VISA</span>
                  </div>
                  <div>
                    <div className="text-gray-900 dark:text-white font-medium">
                      •••• •••• •••• 4242
                    </div>
                    <div className="text-sm text-gray-500 dark:text-gray-400">
                      Expires 12/2025
                    </div>
                  </div>
                  <Button variant="outline" size="sm">
                    Update
                  </Button>
                </div>
              </div>
            </div>
            
            <div className="bg-white dark:bg-dark-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6">
                Billing History
              </h3>
              
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="border-b border-gray-200 dark:border-gray-700">
                      <th className="py-3 px-4 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                        Date
                      </th>
                      <th className="py-3 px-4 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                        Description
                      </th>
                      <th className="py-3 px-4 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                        Amount
                      </th>
                      <th className="py-3 px-4 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                        Invoice
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                    {[
                      { date: '2024-01-01', description: 'Pro Plan (Annual)', amount: '$239.88' },
                      { date: '2023-01-01', description: 'Pro Plan (Annual)', amount: '$239.88' },
                      { date: '2022-01-01', description: 'Pro Plan (Annual)', amount: '$219.88' }
                    ].map((invoice, index) => (
                      <tr key={index}>
                        <td className="py-4 px-4 text-sm text-gray-600 dark:text-gray-300">
                          {new Date(invoice.date).toLocaleDateString()}
                        </td>
                        <td className="py-4 px-4 text-sm text-gray-900 dark:text-white">
                          {invoice.description}
                        </td>
                        <td className="py-4 px-4 text-sm font-medium text-gray-900 dark:text-white">
                          {invoice.amount}
                        </td>
                        <td className="py-4 px-4 text-right">
                          <Button variant="ghost" size="sm" icon={FiDownload}>
                            PDF
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
      
      case 'security':
        return (
          <div className="space-y-6">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
              Security Settings
            </h2>
            
            <div className="bg-white dark:bg-dark-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6">
                Password
              </h3>
              
              <div className="space-y-4 max-w-md">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Current Password
                  </label>
                  <input
                    type="password"
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-dark-700 text-gray-900 dark:text-white"
                    placeholder="Enter your current password"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    New Password
                  </label>
                  <input
                    type="password"
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-dark-700 text-gray-900 dark:text-white"
                    placeholder="Enter new password"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Confirm New Password
                  </label>
                  <input
                    type="password"
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-dark-700 text-gray-900 dark:text-white"
                    placeholder="Confirm new password"
                  />
                </div>
                <div className="pt-2">
                  <Button>
                    Update Password
                  </Button>
                </div>
              </div>
            </div>
            
            <div className="bg-white dark:bg-dark-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Two-Factor Authentication
                </h3>
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400">
                  Not Enabled
                </span>
              </div>
              
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                Add an extra layer of security to your account by enabling two-factor authentication. Once configured, you'll be required to enter a security code whenever you sign in.
              </p>
              
              <Button icon={FiKey}>
                Enable Two-Factor Authentication
              </Button>
            </div>
            
            <div className="bg-white dark:bg-dark-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6">
                Login Sessions
              </h3>
              
              <div className="space-y-4">
                {[
                  { device: 'Chrome on MacOS', location: 'San Francisco, CA', time: 'Now (Current Session)', current: true },
                  { device: 'Safari on iPhone', location: 'San Francisco, CA', time: '2 hours ago' },
                  { device: 'Firefox on Windows', location: 'San Diego, CA', time: '1 day ago' }
                ].map((session, index) => (
                  <div key={index} className="flex items-center justify-between border-b border-gray-200 dark:border-gray-700 last:border-0 pb-4 last:pb-0">
                    <div>
                      <div className="text-gray-900 dark:text-white font-medium">
                        {session.device} {session.current && <span className="text-xs text-primary-600 dark:text-primary-400 ml-2">Current</span>}
                      </div>
                      <div className="text-sm text-gray-500 dark:text-gray-400">
                        {session.location} • {session.time}
                      </div>
                    </div>
                    {!session.current && (
                      <Button variant="outline" size="sm">
                        End Session
                      </Button>
                    )}
                  </div>
                ))}
              </div>
              
              <div className="mt-6">
                <Button variant="outline" icon={FiTrash2}>
                  End All Other Sessions
                </Button>
              </div>
            </div>
          </div>
        );
      
      case 'localization':
        return (
          <div className="space-y-6">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
              Localization Settings
            </h2>
            
            <div className="bg-white dark:bg-dark-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6">
                Language & Region
              </h3>
              
              <div className="space-y-6 max-w-md">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Interface Language
                  </label>
                  <select className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-dark-700 text-gray-900 dark:text-white">
                    <option value="en">English</option>
                    <option value="es">Español</option>
                    <option value="fr">Français</option>
                    <option value="ar">العربية</option>
                    <option value="ur">اردو</option>
                    <option value="hi">हिन्दी</option>
                    <option value="bn">বাংলা</option>
                    <option value="tr">Türkçe</option>
                  </select>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Portfolio Website Language
                  </label>
                  <select className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-dark-700 text-gray-900 dark:text-white">
                    <option value="en">English</option>
                    <option value="es">Español</option>
                    <option value="fr">Français</option>
                    <option value="ar">العربية</option>
                    <option value="ur">اردو</option>
                    <option value="hi">हिन्दी</option>
                    <option value="bn">বাংলা</option>
                    <option value="tr">Türkçe</option>
                  </select>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Time Zone
                  </label>
                  <select className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-dark-700 text-gray-900 dark:text-white">
                    <option value="America/Los_Angeles">Pacific Time (US & Canada)</option>
                    <option value="America/New_York">Eastern Time (US & Canada)</option>
                    <option value="Europe/London">London</option>
                    <option value="Asia/Tokyo">Tokyo</option>
                    <option value="Australia/Sydney">Sydney</option>
                  </select>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Date Format
                  </label>
                  <select className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-dark-700 text-gray-900 dark:text-white">
                    <option value="MM/DD/YYYY">MM/DD/YYYY</option>
                    <option value="DD/MM/YYYY">DD/MM/YYYY</option>
                    <option value="YYYY-MM-DD">YYYY-MM-DD</option>
                  </select>
                </div>
              </div>
            </div>
            
            <div className="bg-white dark:bg-dark-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6">
                Currency Settings
              </h3>
              
              <div className="space-y-6 max-w-md">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Primary Currency
                  </label>
                  <select className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-dark-700 text-gray-900 dark:text-white">
                    <option value="USD">USD - US Dollar</option>
                    <option value="EUR">EUR - Euro</option>
                    <option value="GBP">GBP - British Pound</option>
                    <option value="CAD">CAD - Canadian Dollar</option>
                    <option value="AUD">AUD - Australian Dollar</option>
                    <option value="JPY">JPY - Japanese Yen</option>
                  </select>
                </div>
              </div>
            </div>
            
            <div className="flex justify-end space-x-3">
              <Button variant="outline" size="lg">
                Cancel
              </Button>
              <Button size="lg" loading={isLoading} onClick={handleSave} icon={FiSave}>
                Save Changes
              </Button>
            </div>
          </div>
        );
      
      default:
        return (
          <div className="text-center p-12 text-gray-600 dark:text-gray-400">
            <div className="w-16 h-16 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-4">
              <SafeIcon icon={tabs.find(tab => tab.id === activeTab)?.icon} className="w-8 h-8 text-gray-400" />
            </div>
            <h2 className="text-xl font-medium text-gray-900 dark:text-white mb-2">
              {tabs.find(tab => tab.id === activeTab)?.label} Settings
            </h2>
            <p className="mb-6 max-w-md mx-auto">
              These settings will be available soon. We're working on adding more features to enhance your experience.
            </p>
            <Button variant="outline">
              Coming Soon
            </Button>
          </div>
        );
    }
  };

  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            Settings
          </h1>
        </div>

        {/* Settings Layout */}
        <div className="flex flex-col lg:flex-row gap-6">
          {/* Sidebar */}
          <div className="lg:w-64 flex-shrink-0">
            <div className="bg-white dark:bg-dark-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-4">
              <div className="space-y-1">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    className={`w-full flex items-center px-3 py-2 rounded-lg transition-colors ${
                      activeTab === tab.id 
                        ? 'bg-primary-100 dark:bg-primary-900/30 text-primary-600 dark:text-primary-400' 
                        : 'hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300'
                    }`}
                    onClick={() => setActiveTab(tab.id)}
                  >
                    <SafeIcon icon={tab.icon} className="w-5 h-5 mr-3" />
                    {tab.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
          
          {/* Content */}
          <div className="flex-1">
            {renderTabContent()}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default SettingsPage;